import React from "react";
import { Box, Typography, withStyles } from "@material-ui/core";

const OverflowTypography = withStyles(() => ({
  root: {
    wordWrap: "break-word",
    overflowWrap: "break-word",
  },
}))(Typography) as typeof Typography;

interface FieldProps {
  title: string;
  subtitle: string;
  gutterBottom?: boolean;
}

export const Field: React.FC<FieldProps> = ({
  title,
  subtitle,
  gutterBottom = true,
}) => {
  return (
    <Box minWidth="180px" px={1} mb={gutterBottom ? 2.5 : undefined}>
      <Typography variant="caption" color="textSecondary">
        {title}
      </Typography>
      <OverflowTypography component="p" variant="subtitle1" color="textPrimary">
        {subtitle}
      </OverflowTypography>
    </Box>
  );
};
